<template>
	<div>
		<vs-popup :active.sync="isSidebarActiveLocal" :title="$t('AddPalletItems') + ' - ' + ProductTrackingName"
			@cancel="clearFields" @close="clearFields" >
			<div>
				<ag-grid-vue ref="agGridTable" style="width: 100%; height: 450px" class="ag-theme-alpine w-100 my-4 ag-grid-table"
					:columnDefs="stocktrackingDetailsColumns" :defaultColDef="defaultColDef" :rowData="stocktrackingDetailsList"
					rowSelection="multiple" colResizeDefault="shift" :animateRows="true" @grid-ready="onGridReady"
					:getRowId="getRowId" :isRowMaster="isRowMaster" :suppressCopyRowsToClipboard="true" :masterDetail="true"
					:localeText="localeText" :detailCellRendererParams="detailCellRendererParams"
					@first-data-rendered="onFirstDataRendered">
				</ag-grid-vue>
			</div>
		</vs-popup>
	</div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";

import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData"

export default {
	components: { AgGridVue },
	props: {
		isStockTrackingActive: {
			type: Boolean,
			required: true
		},
		data: {
			default: () => { },
			required: true
		},
	},
	data() {
		return {
			getRowId: null,
			isRowMaster: null,
			detailCellRendererParams: null,
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true
			},
			stocktrackingDetailsColumns: [],
			stocktrackingDetailsList: [],
			ProductTrackingName: ""
		}
	},
	created() {
		this.isRowMaster = (dataItem) => {
			return dataItem ? dataItem.PalletItems.length > 0 : false;
		};
	},
	watch: {
		data() {
		},
		isStockTrackingActive(val) {
			this.getStockTrackingList();
			if (!val) return
			return val
		}
	},
	methods: {
		onFirstDataRendered(params) {
			// arbitrarily expand a row for presentational purposes

		},
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
		},
		clearFields() {
			this.$root.$emit("closePalletItemsPopup2", false);
		},
		getStockTrackingList() {
			const vs = this.$vs;
			this.$store.dispatch("stockTracking/listStockTrackingDetailsList", this.data.ProductTrackingId).then(response => {
				// let costumerList = JSON.parse(response.json);
				if (response.success == true) {
					this.stocktrackingDetailsColumns = []
					let stocktrackingDetailList = this.$store.state.stockTracking.StockTrackingDetails

					this.ProductTrackingName = stocktrackingDetailList.ProductTrackingName
					this.stocktrackingDetailsList = stocktrackingDetailList.Pallets

					let columnList = Object.keys(this.stocktrackingDetailsList[0]);
					/*	this.stockColumns.push({
							width: 150,
							pinned: "left",
							cellRendererFramework: "updateDeleteBtnCellRenderer",
							cellRendererParams: {
								addMethods: "addBarcodePopup",
								addIcon: "ph:barcode"
							}
						},)*/
					columnList.forEach((val, index) => {
						if (val == "PalletId" || val == "PalletItems" || val == "ProductTrackingId")
							this.stocktrackingDetailsColumns.push({ width: 150, hide: true, headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });

						else if (val == "PalletNo") this.stocktrackingDetailsColumns.push({ width: 150, cellRenderer: 'agGroupCellRenderer', headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });
						else this.stocktrackingDetailsColumns.push({ width: 150, headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });


					});
					this.isRowMaster = (dataItem) => {
						return dataItem ? dataItem.PalletItems.length > 0 : false;
					};
					this.getRowId = (params) => {
						return params.data.PalletId;
					};

					this.detailCellRendererParams = {
						detailGridOptions: {
							rowSelection: 'multiple',
							suppressRowClickSelection: true,
							enableRangeSelection: true,
							pagination: false,
							paginationAutoPageSize: false,
							columnDefs: [
								{ headerName: this.$t('PalletNo'), field: 'PalletNo' },
								{ headerName: this.$t('StockCode'), field: 'StockCode' },
								{ headerName: this.$t('Barcode'), field: 'Barcode' },
								{ headerName: this.$t('Quantity'), field: 'Quantity' },
							],
							defaultColDef: {
								sortable: true,
								flex: 1,
							},
						},
						getDetailRowData: (params) => {

							params.successCallback(params.data.PalletItems);
						},
					};
				} else
					console.log(response.statusText)
				/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
			});
		},
	},

	computed: {
		localeText() {
			return i18nData[this.$i18n.locale];
		},
		isSidebarActiveLocal: {
			get() {
				return this.isStockTrackingActive
			},
			set(val) {
				if (!val) {
					this.$emit('closeSidebar')
					// this.$validator.reset()
					// this.initValues()
				}
			}
		},
	},

}
</script>
 